<fc-modal [id]="modalId" [options]="options">
    <div class="image-dialog-container" #container>
        <div
            [ngClass]="{ 'image-dialog-preview-zoomed': zoomEnabled }"
            (pan)="panHandle($event)"
            (tap)="tapHandle($event)"
            class="image-dialog-preview"
            #imageElement
        ></div>
        <div class="image-dialog-close-icon" (click)="handleClose()">
            <fcp-icon [icon]="['fal', 'times']"></fcp-icon>
        </div>
    </div>
    <img [src]="image" class="image-dialog-reference" #responsive />
</fc-modal>
